/* eslint-disable prettier/prettier */
import type { BgType } from "types/common";

export const getNetworkIcon = (networkId: number | undefined) => {
  const path = "/contest/images";
  const ethImagePath = `${path}/ethereum.svg`;
  switch (networkId) {
    case 1:
      return `${path}/ethereum.svg`;
    case 421613:
      return `${path}/arbitrum.svg`;
    case 80001:
      return `${path}/polygon.svg`;
    case 280:
      return `${path}/zksync.svg`;
    default:
      return ethImagePath;
  }
};

export const getEntries = <T extends {}, K extends keyof T>(
  obj?: T,
): Array<[K, T[K]]> => {
  return Object.entries(obj ?? {}) as unknown as Array<[K, T[K]]>;
};

export const isError = (e: unknown): e is Error =>
  !!e && Reflect.has(e, "message");

export const pathnameToBgType = (pathname?: string): BgType | undefined => {
  if (pathname == "/") {
    return "home";
  }
};

export const pathnameToPrevRoute = (pathname?: string, previous?: string) => {
  if (pathname?.includes("watch-position")) {
    return "/";
  }
  if (pathname?.includes("earn")) {
    return "/";
  }
  return previous;
};

const REFERRAL_PATH = "https://marginly.com/contest/r/";

export const createReferralUrl = (referralCode: string) =>
  `${REFERRAL_PATH}${referralCode}`;

export const createShortReferralUrl = (referralCode: string) =>
  `${REFERRAL_PATH.replace("https://", "")}${referralCode.slice(0, 32)}...`;
